// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
    },
    gridContent: {
      padding: '0px 24px',
    },
    paperRoot: {
      marginTop: 32,
      padding: theme.spacing(2),
    },
    tabs: {
      marginTop: theme.spacing(1),
      borderBottom: '1px solid #ddd',
    },
    cardCount: {
      display: 'flex',
      background: '#ddd9',
      padding: '10px 15px !important',
      borderRadius: 7,
      margin: theme.spacing(1, 1, 1, 0),
    },
    marginRight: {
      marginRight: theme.spacing(1.5),
    },
    primaryAmount1: {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
    primaryAmount2: {
      color: '#1CBA27',
      fontWeight: 'bold',
    },
    primaryAmount3: {
      color: '#666',
      fontWeight: 'bold',
    },
    secondaryAmount: {
      marginTop: -5,
      color: '#777',
    },
    resume: {
      display: 'flex',
      alignItems: 'center',
      minWidth: 70,
      height: 42,

      marginRight: 5,
      padding: 7,
      border: '1px solid #14171A',
      borderRadius: 10,
    },
    contentImage: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: 16,
      maxHeight: 16,
      height: '100%',
      marginRight: 5,
    },
    dividerVertical: {
      '&:fist-child': {
        background: '#fff',
      },
      background: '#14171A',
      marginRight: 8,
      marginTop: 1,
    },
    subTiltle: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 700,
      fontSize: 8,
      color: ' #14171A',
      lineHeight: 1,
    },
    value: {
      fontSize: 12,
      color: ' #14171A',
      lineHeight: 1,
    },
    contentTotalEntry: {
      display: 'grid',
      marginRight: 8,
    },
    addButton: {
      background: '#0094FF',
      borderRadius: 12,
      color: '#fff',
      minHeight: 40,
      padding: '0px 16px',
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
    },
    contentGroupings: {
      display: 'flex',
      width: 58,
      height: 35,
    },

    groupings: {
      height: 35,
      width: 35,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#F5F8FA',
      cursor: 'pointer',
      borderRadius: '50%',
    },
    badge: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 22,
      height: 22,
      fontSize: 13,
      borderRadius: '50%',
      background: '#EA9427',
      color: theme.palette.colors.white,
      position: 'relative',
      bottom: 6,
      right: 12,
    },
  }),
);

export default useStyles;
